import { Routes } from '@angular/router';
import { Routing } from '@core/constants/routing.const';
import { authGuard } from '@core/guards/auth.guard';
import { unauthGuard } from '@core/guards/unauth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: Routing.Secure,
    pathMatch: 'full',
  },
  {
    path: 'confirm-appointment',
    loadComponent: () =>
      import('./ui/pages/confirm-appointment/confirm-appointment.component').then(
        (m) => m.ConfirmAppointmentComponent
      ),
  },
  {
    path: 'confirm-recurrence',
    loadComponent: () =>
      import('./ui/pages/confirm-appointment/confirm-appointment.component').then(
        (m) => m.ConfirmAppointmentComponent
      ),
  },
  {
    path: Routing.Forbidden,
    loadComponent: () =>
      import('@hms/forbidden/forbidden.component').then(
        (m) => m.ForbiddenComponent
      ),
  },
  {
    path: Routing.Auth,
    loadChildren: () =>
      import('@hms/layouts/public-layout/public-layout.routs').then(
        (m) => m.publicRoutes
      ),
    canActivate: [unauthGuard],
  },
  {
    path: Routing.Secure,
    loadChildren: () =>
      import('@hms/layouts/secure-layout/secure-layout.routes').then(
        (m) => m.secureRoutes
      ),
    canActivate: [authGuard],
  },
  {
    path: `${Routing.DocumentViewer}`,
    loadComponent: () =>
      import('@hms/document-viewer/document-viewer.component').then(
        (m) => m.DocumentViewerComponent
      ),
  },
  {
    path: `${Routing.PrintTemplate}`,
    loadComponent: () =>
      import('@hms/print-template/print-template.component').then(
        (m) => m.PrintTemplateComponent
      ),
  },
  {
    path: 'ui',
    loadChildren: () => import('./ui/ui.routes').then((m) => m.uiRoutes),
  },
  { path: '**', redirectTo: Routing.Auth },
];
